import { useAtomValue } from 'jotai'
import React, { useContext } from 'react'

import { RichTextEditor } from 'packages/components/RichText'

import { WaringText } from '@/components/Styled'
import { EditPaperContext } from '@/features/test-paper/pages/EditPaper/context'

import { isValidQuestionFieldAtom } from '../../atom'
import { EditProductQuestionItemProps } from '../../types'
import { editSubQuestion } from '../../utils'

/**
 * 简答题答案 - 编辑
 *
 * @param props - 参数
 * @param props.curQuestion - 当前题目
 * @param props.subQuestions - 字子题目
 * @param props.treeNodeId - 树节点 id
 * @param props.setSubQuestions - 设置子题目
 * @returns React.ReactNode
 */
export const EditSubShortAnswer: React.FC<EditProductQuestionItemProps> = ({
  curQuestion,
  subQuestions,
  treeNodeId,
  setSubQuestions,
}) => {
  const { limitLevel } = useContext(EditPaperContext)
  const isValidField = useAtomValue(isValidQuestionFieldAtom)
  const value = curQuestion.standardAnswers
    ? curQuestion.standardAnswers[0]
    : undefined
  return (
    <>
      <RichTextEditor
        readOnly={limitLevel > 0}
        minHeight={64}
        value={value}
        onChange={(v) => {
          const newQuestions = editSubQuestion(subQuestions, treeNodeId || 0, {
            standardAnswers: [v],
          })
          setSubQuestions(newQuestions)
        }}
        excludeKeys={[
          'headerSelect',
          'group-upload',
          'insertLink',
          'fullScreen',
        ]}
        insertKeys={{
          index: 17,
          keys: ['uploadImage', 'insertFormula'],
        }}
      />
      {value || !isValidField ? null : <WaringText>请添加答案选项</WaringText>}
    </>
  )
}
